var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Session Timeout",
        "no-close-on-backdrop": "",
        "hide-header-close": ""
      },
      model: {
        value: _vm.showPopup,
        callback: function($$v) {
          _vm.showPopup = $$v
        },
        expression: "showPopup"
      }
    },
    [
      _c("p", [_vm._v("Your session is about to expire in")]),
      _vm._v(" "),
      _c("p", [_vm._v(" " + _vm._s(_vm.formatTime(_vm.countdownTime)))]),
      _vm._v(" "),
      _c("p", [
        _vm._v(' To stay logged in, please select "Continue Session."')
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal-footer-buttons",
          staticStyle: { "justify-content": "space-between", display: "flex" },
          attrs: { slot: "modal-footer" },
          slot: "modal-footer"
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-footer-left",
              staticStyle: { "padding-left": "200px" }
            },
            [
              _c(
                "button",
                {
                  staticClass: "modal-button primary-button",
                  on: { click: _vm.handleContinueSession }
                },
                [_vm._v("Continue Session")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal-footer-right",
              staticStyle: { "padding-left": "20px" }
            },
            [
              _c(
                "button",
                {
                  staticClass: "modal-button danger-button",
                  on: { click: _vm.logoutSession }
                },
                [_vm._v("Log Out")]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-94b1f8c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94b1f8c0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sessionlogout.vue
// module id = 960
// module chunks = 2